import React, { Component} from 'react'
import axios from 'axios';
import { Accordion, Card} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Chart from "react-apexcharts"
import '../../assets/css/modified.css'
import '../../assets/css/tables.scss'
import moment from 'moment-timezone'; 
import logo from '../../assets/img/logoImage/logo.png'
import fitfactory from '../../assets/img/logoImage/fitfactory.png'
import in4 from '../../assets/img/logoImage/Inc4.0.png'
import simulogo from '../../assets/img/logoImage/simulanis.png'
import mmu from '../../assets/img/logoImage/Manchester-Metropolitan-University.png'
import ufi from '../../assets/img/logoImage/ufi.png'
import jsPDF from "jspdf"; 
import html2canvas from "html2canvas";
import "../../assets/css/validate.css"



const DefaultState = {
    mcqReport: [],
    selected_report: {},
    viewMode: "ALLREPORT",
}

const login_detail = JSON.parse(localStorage.getItem("user_Detail"));

export default class report extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: {},
            reportTotalTimes: [],
            viewMode: "ALLREPORT",     // MCQREPORT, //GUIDED, //NORECORD, //ALLREPORT
            selected_report: {},
            mcqReport: [],
            product: {},
            m_col: {},
            defaultMode: "",
            report_length:0,
            userDetail:null,
            showModel:true,
            series: [
                {
                    name: 'Score',
                    type: 'bar',
                    data: [],
                    // data: [3,2,6]
                    },
                    
                    {
                    name: 'Total time(in Minutes)',
                    type: 'bar',
                    data: []
                    // data: [25, 15, 21]
                    },
                    ],
       
              options: {
                chart: {
                  height: 350,
                  type: 'bar',
                  stacked: false,
                  toolbar: {   // control Download Menu option
                    show: false,
                    tools: {
                      download: true
                    }
                  }
                },
                
                annotations: {
                    yaxis: [
                      {
                        y: 4.5,
                        y2:null,
                        borderColor: '#C45C5C',
                        fillColor: '#C45C5C',
                        opacity: 1,
                        strokeDashArray: 0,
                        width: '100%',
                        height:5,
                        label: {
                          borderColor: '#C45C5C', 
                          borderRadius:2,
                          style: {
                            color: '#fff',
                            background: '#C45C5C',
                          },
                          text: 'Score_Baseline'
                        }
                      },
                       
                    ]
                  },


                plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '60%',
                      endingShape: 'rounded'
                    },
                  },


                dataLabels: {
                  enabled: true
                },
               
                stroke: {
                   width: [0,0]
                  
                },
               
                title: {
                  text: 'Score and Time graph',
                  align: 'left',
                  offsetX: 10
                },
              
                xaxis: {
                    categories: [],
                    // categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015],
                },
              
                yaxis: [
                  {
                    axisTicks: {
                      show: false,
                    },
                    axisBorder: {
                      show: true,
                      color: '#008FFB'
                    },
                    labels: {
                        offsetX:-20,
                      style: {
                        colors: '#008FFB',
                      }
                    },
                    title: {
                      text: "Score",
                      style: {
                        color: '#008FFB',
                      }
                    },
                    tooltip: {
                      enabled: false
                    } 
                  },
                  
                  {
                    seriesName: 'Total Time(in Minute)',
                    opposite: true,
                    axisTicks: {
                      show: true,
                    },
                    axisBorder: {
                      show: true,
                      color: 'rgb(0, 227, 150)'
                    },
                    labels: {
                      offsetX:-22,
                    //   rotate: -90,
                      style: {
                        colors: 'rgb(0, 227, 150)',
                      },
                    },
                    title: {
                      text: "Total Time(in Minute)",
                      style: {
                        color: 'rgb(0, 227, 150)',
                      }
                    }
                  },
                ],
              
                tooltip: {
                  fixed: {
                    // enabled: true,
                    // position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                    offsetY: 30,
                    offsetX: 60
                  },
                  x: {
                    formatter: function (val) {
                        return "Date: " + val
                    }
                  }
                },
               
                legend: {
                  horizontalAlign: 'left',
                  offsetX: 40
                },
                 

              },
        }
        
     }

    componentDidMount() {
        this.fetchAllReports();
    }

    fetchAllReports  = ()=> {
        var AllDate=[];
        var AllScore=[];
        var AllTime=[];


         let _this = this
         if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
           }
        const thePath = window.location.href;
        let userId = thePath.substring(thePath.lastIndexOf('/') + 1)
        const parts = thePath.split('/');
        let courseId = parts[parts.length-2];
         let req_data = {
                user_id:userId,
                courseId:courseId,
            }
            axios.post(`${process.env['REACT_APP_HOST']}/api/mcqmaster/fetch_total_report/`, req_data)
            .then(function (response) {
                console.log(response)
                if (response.data.error == false) {
                    let m_col = {};

                    if (response.data.product.milestone_collection) {
                        response.data.product.milestone_collection.map(list => {

                            m_col[list.m_no] = list.m_name
                        })
                    }
                    let viewMode = ""
                    if (response.data.reports.length == 0) {
                        viewMode = "NORECORD"
                    } else if (response.data.reports[0].isguided == true) {
                        viewMode = "GUIDED"
                    } else {
                        viewMode = "ALLREPORT"
                    }
                    _this.setState({
                        reportTotalTimes: response.data.reports,
                        report_length: response.data.reports.length,
                        product: response.data.product,
                        m_col: m_col,
                        viewMode: viewMode,
                        defaultMode: viewMode,
                        userName:response.data.userDetail.firstName +' '+response.data.userDetail.lastName,
                        userEmail:response.data.userDetail.email
                    })

                    if(response.data.reports.length>=8){ 
                        _this.state.reportTotalTimes.map((list,index)=>{
                             if(index < 7){
                            let s_date = new Date(list.start_datetime); 
                            let e_date = new Date(list.updatedAt);
                            let diff = Math.abs(e_date - s_date);
                            let ms = diff % 1000;
                            diff = (diff - ms) / 1000;
                            let s = diff % 60;
                            diff = (diff - s) / 60;
                            let m = diff % 60;
                            diff = (diff - m) / 60;
                            let h = diff;
                            
                            AllDate.unshift(list.Create_Date);
                            AllScore.unshift(list.sucess_response);
                            
                            if(h>=1){
                                var b=0;
                                b=h*60; 
                                b=b+m; 
                            AllTime.unshift(b)
                            }else{
                              AllTime.unshift(m)
                            }

                        }
                            })
                     }else{
                    _this.state.reportTotalTimes.map((list,index)=>{
                    let s_date = new Date(list.start_datetime); 
                    let e_date = new Date(list.updatedAt);
                    let diff = Math.abs(e_date - s_date);
                    let ms = diff % 1000;
                    diff = (diff - ms) / 1000;
                    let s = diff % 60;
                    diff = (diff - s) / 60;
                    let m = diff % 60;
                    diff = (diff - m) / 60;
                    let h = diff;

                    AllDate.unshift(list.Create_Date);
                    AllScore.unshift(list.sucess_response);
                    
                    if(h>=1){
                        var b=0;
                        b=h*60; 
                        b=b+m; 
                    AllTime.unshift(b)
                    }else{
                      AllTime.unshift(m)
                    }
                    })
                        }
                  
                  _this.setState({
                    series: [
                        {
                          name: "Score",
                          data: AllScore,
                        },
                        {
                          name: "Total time(in Minutes)",
                          data: AllTime,
                        },
                      ],
                      options: {
                        xaxis: {
                              categories:AllDate
                           }
                      },
                        })

                   }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    seeReport = (obj) => {
        let _this = this
        this.setState({ selected_report: obj, viewMode: "MCQREPORT",showModel:false})
        let req_data = {
            sessionId: obj._id
        }
        axios.post(`${process.env['REACT_APP_HOST']}/api/mcqmaster/fetch_mcq_report/`, req_data)
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.reports.length === 1) {
                        let rawData = response.data.reports[0].mcq_data.sort((a, b) => a.moduleId - b.moduleId)
                        let largestModule = rawData[rawData.length - 1].moduleId
                        let array = new Array()
                        rawData.map((list, index) => {
                            let currentIndex = array.findIndex(x => x.moduleId === list.moduleId)
                            if (currentIndex !== -1) {
                                array[currentIndex].data.push(list)
                            } else {
                                array.push({ moduleId: list.moduleId, data: [list] })
                            }
                            if (rawData.length - 1 === index) {
                                _this.setState({ mcqReport: array })
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    modelPdf = (e) => {
        
        var totalTime='';
        var today = new Date(),
        date = today.getDate().toString().padStart(2, "0") + '-' + (today.getMonth() + 1).toString().padStart(2, "0") +'-' + today.getFullYear();
        const minutes = String(today.getMinutes()).padStart(2, '0');

        var timeH = today.getHours(); 
                if(timeH<12){
                    totalTime = `${timeH}:${minutes}AM`;
                }
                else if(timeH==12){
                    totalTime = `${timeH}:${minutes}PM`;
                }
                else{
                    var t = timeH-12;
                    totalTime = `${t}:${minutes}PM`;
                }

                html2canvas(document.querySelector("#model"),{ useCORS: true,scale:2}) //  useCORS: true    ...Used to download server Side Image
                .then((canvas) => {
                    const imgData = canvas.toDataURL("image/jpg");
                    const pdf = new jsPDF("l");
                    // pdf.setFont("helvetica");
                    // pdf.setFontType("bold");
                    pdf.addImage(logo, "JPEG", 20,12,40,15);
    
                    pdf.setFontSize(20);
                    pdf.text(120,20,`Assessment Report`);
    
                    pdf.setFontSize(10);
                    pdf.text(20,40,`Name: `);
                    pdf.setFontSize(9);
                    pdf.text(32,40,`${this.state.userName}`);
    
                    pdf.setFontSize(10);
                    pdf.text(20,46,`Email: `);
                    pdf.setFontSize(9);
                    pdf.text(32,46,`${this.state.userEmail}`);
                    
                    pdf.setFontSize(10);
                    pdf.text(20,52,`Course Name: `);
                    pdf.setFontSize(9);
                    pdf.text(44,52,`${this.state.product.name}`);
    
                    // pdf.addImage(imgData, "JPEG", 0,40,250,0);
                    pdf.addImage(imgData, "JPEG", 19,65,280,0);
    
                    // pdf.setFontSize(7);
                    // pdf.text(130,95,`Report generated Time: `);
                    // pdf.setFontSize(6);
                    // pdf.text(157,95,`${totalTime} ${date}`);
    
                    // pdf.setFontSize(14);
                    // pdf.text(87,120,"Powered by:");
                    // pdf.addImage(fitfactory, "JPEG", 20,125,28,11);
                    // pdf.addImage(in4, "JPEG", 52,125,28,11);
                    // pdf.addImage(ufi, "JPEG", 87,125,28,11);
                    // pdf.addImage(mmu, "JPEG", 123,125,28,11);
                    // pdf.addImage(simulogo, "JPEG", 159,125,28,11);
    
    
    
                    pdf.setFontSize(8);
                    pdf.text(122,171,`Report generated on: `);
                    pdf.setFontSize(7);
                    pdf.text(150,171,`${date}  ${totalTime}`);
    
                    pdf.setFontSize(14);
                    pdf.text(127,180,"Powered by:");
                    pdf.addImage(fitfactory, "JPEG", 60,185,28,11);
                    pdf.addImage(in4, "JPEG", 92,185,28,11);
                    pdf.addImage(ufi, "JPEG", 127,185,28,11);
                    pdf.addImage(mmu, "JPEG", 163,185,28,11);
                    pdf.addImage(simulogo, "JPEG", 199,185,28,11);
    
    
                    pdf.save(`${this.state.userName}.pdf`);
    
    
                }).catch((err)=>{
                    console.log(err)
                })




          }

          back=(e)=>{
            window.location.reload()
            // this.setState({ 
            //     ...DefaultState,
            //      viewMode: this.state.defaultMode, 
            //     //  showModel:true 
            //     })
        }


    render() {
        const { m_col } = this.state
        return (
            <>
                <main className="pt-3">
                    <section className="gap-full">
                        <div className="container">
                            <div id="msg"></div>
                            {/* <div className="row"> */}
                                <div class="form-group row">
                                    <div class="col col-sm-3 col-md-3 col-lg-3 col-form-label">Course Name</div>
                                    <div class="col col-sm-9 col-md-9 col-lg-9 col-form-label">{this.state.product.name}</div>
                                </div>
                                {["GUIDED", "NORECORD"].includes(this.state.viewMode) ? null :
                                    <div class="form-group row">
                                        <div class="col-sm-3 col-md-3 col-lg-3 col-form-label">Milestones</div>
                                        <div class="col-sm-9 col-md-9 col-lg-9 col-form-label">{this.state.product.modulesNo}</div>
                                    </div>
                                }
                            {/* </div> */}
                            <br />


                            {this.state.viewMode == "ALLREPORT" ?
                                <div className="row reports overflowReport">
                                    <div className="col-12">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th scope="col">S.N</th>
                                                    <th scope="col">Success</th>
                                                    <th scope="col">Percentage</th>
                                                    <th scope="col">Start Time</th>
                                                    <th scope="col">End Time</th>
                                                    <th scope="col">Play Time</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.reportTotalTimes.map((list, index) => {
                                                    let s_date = new Date(list.start_datetime);
                                                    let e_date = new Date(list.updatedAt);
                                                    let diff = Math.abs(e_date - s_date);
                                                    let ms = diff % 1000;
                                                    diff = (diff - ms) / 1000;
                                                    let s = diff % 60;
                                                    diff = (diff - s) / 60;
                                                    let m = diff % 60;
                                                    diff = (diff - m) / 60;
                                                    let h = diff;
                                                    let ss = s <= 9 && s >= 0 ? `0${s}` : s;
                                                    let mm = m <= 9 && m >= 0 ? `0${m}` : m;
                                                    let hh = h <= 9 && h >= 0 ? `0${h}` : h;
                                                    let percentage = ((100 * list.sucess_response) / list.count_responses).toFixed(1)
                                                    return (<tr>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{list.sucess_response + "/" + list.count_responses}</td>

                                                        <td> <div class="progress">
                                                            <div class="progress-bar" role="progressbar" style={{ width: `${percentage == "NaN" ? 0 : percentage}%` }} aria-valuenow={percentage == "NaN" ? 0 : percentage} aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                            <span className="percentage">{percentage == "NaN" ? 0 : percentage}%</span>
                                                        </td>
                                                        <td>{`${moment.tz(s_date, 'Europe/London').format('DD/MM/YYYY hh:mm A z')}  `}</td>
                                                        <td>{`${moment.tz(e_date, 'Europe/London').format('DD/MM/YYYY hh:mm A z')}  `}</td>
                                                        <td>{`${hh + ' Hours, ' + mm + ' Minutes, ' + ss + " Seconds "}`}</td>
                                                        <td><button type="button" onClick={() => this.seeReport(list)} class="btn btn-primary btn-sm">See Report</button></td>
                                                    </tr>)
                                                }
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                : null}

                            {this.state.viewMode == "GUIDED" ?
                                <div className="row reports">
                                    <div className="col-12">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th scope="col">S.N</th>
                                                    <th scope="col">Start Time</th>
                                                    <th scope="col">End Time</th>
                                                    <th scope="col">Play Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.reportTotalTimes.map((list, index) => {
                                                    let s_date = new Date(list.start_datetime);
                                                    let hh, mm, ss;
                                                    if (list.end_datetime != null) {
                                                        let e_date = new Date(list.end_datetime);
                                                        let diff = Math.abs(e_date - s_date);
                                                        let ms = diff % 1000;
                                                        diff = (diff - ms) / 1000;
                                                        let s = diff % 60;
                                                        diff = (diff - s) / 60;
                                                        let m = diff % 60;
                                                        diff = (diff - m) / 60;
                                                        let h = diff;
                                                        ss = s <= 9 && s >= 0 ? `0${s}` : s;
                                                        mm = m <= 9 && m >= 0 ? `0${m}` : m;
                                                        hh = h <= 9 && h >= 0 ? `0${h}` : h;

                                                    }

                                                    return (<tr>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{`${moment.tz(s_date, 'Europe/London').format('DD/MM/YYYY hh:mm A z')}  `}</td>
                                                        <td>{`${list.end_datetime != null ? moment.tz(list.end_datetime, 'Europe/London').format('DD/MM/YYYY hh:mm A z') : "N.A"}  `}</td>
                                                        <td>{`${list.end_datetime != null ? hh + ' Hours, ' + mm + ' Minutes, ' + ss + " Seconds " : "N.A"}`}</td>
                                                    </tr>)
                                                }
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                : null}

                            {this.state.viewMode == "NORECORD" ?
                                <div className="row reports">
                                    <p class="font-weight-bold">No records found.</p>
                                </div>
                                : null}

                                {this.state.viewMode == "MCQREPORT" ?
                                <div className="row">
                                    <div className="d-flex align-items-end flex-column">
                                        {/* <button type="button" onClick={() => this.setState({ ...DefaultState, viewMode: this.state.defaultMode })} className="btn btn-primary btn-sm mb-2"> <i className="fa fa-angle-left"></i> Back</button> */}
                                        <button type="button" onClick={this.back} className="btn btn-primary btn-sm mb-2"> <i className="fa fa-angle-left"></i> Back</button>
                                    </div>
                                    <div className="col-12">
                                        <Accordion className="accreport" defaultActiveKey="0" flush>
                                            {this.state.mcqReport.map((list, index) => {
                                                let totalCorrect = list.data.filter(x => x.mcq_info.mcq_reponse == 1).length
                                                let total = list.data.length
                                                let percentage = ((totalCorrect / total) * 100).toFixed(1)
                                                return (
                                                    <Card className="mb-2">
                                                        <Accordion.Item eventKey={`${index}`}>
                                                            <Accordion.Header>
                                                                {m_col[list.moduleId] == undefined ? list.moduleId : m_col[list.moduleId]}

                                                                <div class="mcorrectid ">({totalCorrect} / {total}) <span>Milestone wise assesment</span> </div>

                                                                <div class="progress w-40 " style={{ marginLeft: "30px" }}>

                                                                    <div class="progress-bar" role="progressbar" style={{ width: `${percentage == "NaN" ? 0 : percentage}%` }} aria-valuenow={percentage == "NaN" ? 0 : percentage} aria-valuemin="0" aria-valuemax="100"></div>
                                                                </div>
                                                                <span className="percentage">{percentage == "NaN" ? 0 : percentage}%</span>

                                                            </Accordion.Header>
                                                            <Accordion.Body>
                                                                <Card.Body>
                                                                    <div className="table-responsive">
                                                                        <table className="table table-bordered text-center mb-0" style={{"borderWidth":"1px", 'borderColor':"#aaaaaa", 'borderStyle':'solid'}}>
                                                                            
                                                                            <thead style={{ background: '#d4e6fd' }}>
                                                                                <tr>
                                                                                    <td style={{"borderWidth":"1px", 'borderColor':"#aaaaaa", 'borderStyle':'solid'}} scope="col" rowSpan="2">SN</td>
                                                                                    <td style={{"borderWidth":"1px", 'borderColor':"#aaaaaa", 'borderStyle':'solid'}} scope="col" rowSpan="2"> <span>Question</span>  <br />
                                                                                        <span style={{ fontSize: '14px', whiteSpace: 'nowrap', fontWeight: '600' }}>No. of question in the module</span>
                                                                                    </td>
                                                                                    <td style={{"borderWidth":"1px", 'borderColor':"#aaaaaa", 'borderStyle':'solid'}} scope="col" colSpan="4" className="p-0">
                                                                                        <span style={{ margin: '8px 0px', display: 'block' }}>Selected Option</span>

                                                                                    </td>
                                                                                    <td  style={{"borderWidth":"1px", 'borderColor':"#aaaaaa", 'borderStyle':'solid', whiteSpace: 'nowrap', padding: '0px 15px'}} className="p-0" rowSpan="2" scope="col" >
                                                                                        <span style={{ margin: '8px 15px' }}>Result</span>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr className="row2">
                                                                                    <td style={{whiteSpace:'nowrap'}}>Correct Option</td>
                                                                                    <td >Option A</td>
                                                                                    <td>Option B</td>
                                                                                    <td>Option C</td>
                                                                                     
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {list.data.map((child_list, child_index) =>
                                                                                    <tr key={child_index}>
                                                                                        <td>{child_index + 1}</td>
                                                                                        <td>{child_list.question}</td>
                                                                                        <td>{child_list.mcq_info.mcq_reponse == 1 ? <button type="button" className="correctopt">{child_list.correct}</button> : child_list.correct}</td>
                                                                                        <td>{child_list.mcq_info.mcq_reponse == 2 ? <button type="button" className="optdanger">{child_list.option1}</button> : child_list.option1}</td>
                                                                                        <td>{child_list.mcq_info.mcq_reponse == 3 ? <button type="button" className="optdanger">{child_list.option2}</button> : child_list.option2}</td>
                                                                                        <td>{child_list.mcq_info.mcq_reponse == 4 ? <button type="button" className="optdanger">{child_list.option3}</button> : child_list.option3}</td>
                                                                                        <td>
                                                                                            {child_list.mcq_info.mcq_reponse == 1 ?
                                                                                                <i className="fa fa-check" style={{ color: '#0de010', fontSize: '18px' }}></i>
                                                                                                :
                                                                                                <i className="fa fa-times" style={{ color: '#ec490f', fontSize: '18px' }}></i>
                                                                                            }
                                                                                        </td>
                                                                                         
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    </Card>
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                                : null}
                        </div>

                        


                       {/* Graph start */}
                       { this.state.showModel== true ?
                      <>
                        {this.state.report_length!=0?
                                    <>
                                {/* PDF Download Button */}
                                    <div className="container">
                                    <div className="row">
                                        <div class="col-md-12" style={{textAlign:'right', marginBottom:'-30px'}}>
                                            <button onClick={this.modelPdf} className="btn btn-success  btn-sm px-4"> <i className="fa fa-download" style={{marginRight:'5px'}}></i> Pdf</button>
                                        </div>
                                    </div>
                                    </div>

                                {/* PDF Download Model */}
                                    <div id="model">
                                        <div id="chart">
                                            <Chart
                                            options={this.state.options}
                                            series={this.state.series}
                                            type="bar"
                                            height={300}
                                            />
                                        </div>
                                    </div>
                                </>
                            :
                            null
                                    }
                                    </>:
                        null 
                                }
                       {/* Graph end */}


                    </section>
                </main>
                <div>
                </div>

            </>
        )
    }



}